import {ElNotification} from 'element-plus';

// Embedded into the bundle at build time by scripts/build-version.js - see
// that file for why this exists alongside public/version.json.
const BUILD_VERSION = process.env.VUE_APP_BUILD_VERSION;

const CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

let notified = false;
let intervalId = null;

async function checkForNewVersion() {
    if (notified || !BUILD_VERSION) {
        return;
    }

    try {
        // cache: 'no-store' bypasses the HTTP cache for this specific
        // request regardless of whatever cache headers the server sends -
        // this is what makes the check reliable even if index.html/static
        // assets end up cached somewhere outside our control.
        const response = await fetch(`/version.json?t=${Date.now()}`, {cache: 'no-store'});

        if (!response.ok) {
            return;
        }

        const data = await response.json();

        if (data.version && data.version !== BUILD_VERSION) {
            notified = true;

            ElNotification({
                title: 'Update Available',
                message: 'A new version of Kodi is available. Refresh to get the latest changes.',
                type: 'info',
                duration: 0,
                position: 'bottom-right',
                onClick: () => window.location.reload(),
            });
        }
    } catch (e) {
        // Offline, or version.json briefly unavailable mid-deploy - not
        // worth surfacing to the user, just try again next interval.
    }
}

export function startVersionCheck() {
    if (intervalId) {
        return;
    }

    checkForNewVersion();

    intervalId = setInterval(checkForNewVersion, CHECK_INTERVAL_MS);

    // Catches the common case of a tab left open for hours - check the
    // moment the user comes back to it rather than waiting on the interval.
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            checkForNewVersion();
        }
    });
}
